function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function getAttribute(tag, attributeName, options) {
  var debug = options && options.debug || false;
  if (debug) console.log("getting " + attributeName + " in " + tag);
  var xml = _typeof(tag) === "object" ? tag.outer : tag;
  var pattern = "".concat(attributeName, "\\=\"([^\"]*)\"");
  if (debug) console.log("pattern:", pattern);
  var re = new RegExp(pattern);
  var match = re.exec(xml);
  if (debug) console.log("match:", match);
  if (match) return match[1];
}

module.exports = getAttribute;